/**
*  AUTHOR : 
*  WEBSITE :  sca.pearlgreen.com
*  DATE : 14-06-2019
*/

//@MODULE ManufacturerLinks

define('Catalogs.Model'
,	[	'Backbone'
	,	'underscore'
	,	'Utils'
	]
,	function (
		Backbone
	,	_
	,	Utils
	)
{
	'use strict';

	//@class ManufacturerLinks.Model
	// [Backbone.validation](https://github.com/thedersen/backbone.validation)
	//@extend Backbone.Model

	return Backbone.Model.extend({

		//@property {String} urlRoot
		urlRoot: Utils.getAbsoluteUrl('services/Catalogs.Service.ss')

		//@property {Object} validation. Backbone.Validation attribute used for validating the form before submit.
	,	validation: 
		{
			
		}
		
	});
});
